import(/* webpackMode: "eager" */ "/app/app/[locale]/error.js");
